// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner--32UKe"};